import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { SelectTransportCategoryComponent } from './select-transport-category/select-transport-category.component';
import { SelectTypeComponent } from './select-type/select-type.component';
import { SelectCalculationModeComponent } from './select-calculation-mode/select-calculation-mode.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { TransportFormComponent } from './transport-form/transport-form.component';
import {
  TransportCategory,
  TransportMode,
} from 'src/app/trip-calculator/models/transport';
import { Subscription } from 'rxjs';
import { TripService } from 'src/app/trip-calculator/services/trip.service';
import { SelectCustomTransportFactorComponent } from './select-custom-transport-factor/select-custom-transport-factor.component';

@Component({
  selector: 'app-transport-modal',
  imports: [
    InputTextModule,
    ButtonModule,
    SelectTransportCategoryComponent,
    SelectTypeComponent,
    SelectCalculationModeComponent,
    TranslocoPipe,
    TransportFormComponent,
    SelectCustomTransportFactorComponent,
  ],
  templateUrl: './transport-modal.component.html',
})
export class TransportModalComponent implements OnInit, OnDestroy {
  transportFormService = inject(TransportFormService);
  prestationModalService = inject(PrestationModalService);
  tripService = inject(TripService);
  valueChangeSubscription?: Subscription;
  loading: boolean = false;
  ngOnInit() {
    this.valueChangeSubscription =
      this.transportFormService.transportForm.valueChanges.subscribe(() => {
        this.transportFormService.updateConditionnalDisplay();
      });
  }
  ngOnDestroy() {
    this.valueChangeSubscription?.unsubscribe();
  }

  close() {
    this.prestationModalService.close();
    this.transportFormService.resetFormGroup();
  }

  continue() {
    if (
      this.transportFormService.transportCategory() ===
      TransportCategory.CustomFactor
    ) {
      this.transportFormService.transportForm
        .get('type')
        ?.setValue(TransportMode.CustomFactor);
    }
    if (
      this.transportFormService.transportCategory() === TransportCategory.Cruise
    ) {
      this.transportFormService.transportForm
        .get('type')
        ?.setValue(TransportMode.Cruise);
      this.transportFormService.step.set(3);
    } else {
      this.transportFormService.step.update((step) => step + 1);
    }
  }

  back() {
    if (
      this.transportFormService.transportCategory() === TransportCategory.Cruise
    ) {
      this.transportFormService.step.set(1);
    } else {
      this.transportFormService.step.update((step) => step - 1);
    }
  }
  submit() {
    this.loading = true;
    this.transportFormService.submitTransport()?.subscribe({
      next: () => {
        this.loading = false;
        this.revalidateTrip();
        this.close();
      },
      error: () => (this.loading = false),
    });
  }

  /**
   * Trigger re-validation of the trip after successful save
   */
  private revalidateTrip() {
    const trip = this.tripService.trip();
    if (!trip?.id) return;

    this.tripService.triggerValidation(trip.id);
  }
  get disableContinue() {
    if (this.transportFormService.step() === 1) {
      return !this.transportFormService.transportCategory();
    } else {
      return (
        // this.transportFormService.transportForm.invalid ||
        !this.transportFormService.calculationMode()
      );
    }
  }
}
